import React, { useState, useEffect } from "react";

export default function Apresentacao() {
    const textoCompleto = "Sistema de Automação Predial";
    const [texto, setTexto] = useState("S");
    const [indice, setIndice] = useState(1);
    const [deletando, setDeletando] = useState(false);

    // ============================================
    // 🎮 CONTROLES DE VELOCIDADE E TIMING
    // ============================================
    const VELOCIDADE_DIGITACAO = 100;  // ⌨️ Tempo entre cada letra ao digitar (em ms)
    const VELOCIDADE_DELECAO = 50;     // ⌫ Tempo entre cada letra ao apagar (em ms)
    const PAUSA_APOS_DIGITAR = 2000;   // ⏸️ Pausa depois de terminar de digitar (em ms)
    const PAUSA_APOS_APAGAR = 1000;    // ⏸️ Pausa depois de voltar ao "S" (em ms)
    // ============================================

    useEffect(() => {
        const timer = setTimeout(() => {
            if (!deletando) {
                // ✍️ MODO DIGITAÇÃO
                if (indice < textoCompleto.length) {
                    setTexto(textoCompleto.substring(0, indice + 1));
                    setIndice(indice + 1);
                } else {
                    // Terminou de digitar - aguarda e começa a deletar
                    setTimeout(() => {
                        setDeletando(true);
                    }, PAUSA_APOS_DIGITAR);
                }
            } else {
                // 🗑️ MODO DELEÇÃO
                if (indice > 1) {
                    setTexto(textoCompleto.substring(0, indice - 1));
                    setIndice(indice - 1);
                } else {
                    // Voltou ao "S" - aguarda e recomeça a digitar
                    setTimeout(() => {
                        setDeletando(false);
                        setIndice(1);
                    }, PAUSA_APOS_APAGAR);
                }
            }
        }, deletando ? VELOCIDADE_DELECAO : VELOCIDADE_DIGITACAO);

        return () => clearTimeout(timer);
    }, [indice, deletando, textoCompleto]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-emerald-50 via-green-50 to-teal-50">
            <div className="text-center space-y-8 p-8">
                {/* Título com efeito de digitação */}
                <div className="relative">
                    <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-green-600 to-emerald-600 min-h-[120px] flex items-center justify-center">
                        {texto}
                        <span className="inline-block w-1 h-16 bg-green-600 ml-2 animate-pulse" />
                    </h1>
                </div>

                {/* Subtítulo */}
                <div className="space-y-4 animate-fade-in">
                    <p className="text-xl md:text-3xl text-gray-600 font-medium">
                        CMD Automação
                    </p>
                    <p className="text-lg text-gray-500">
                        Tecnologia e inovação para seu condomínio
                    </p>
                </div>

                {/* Ícones decorativos */}
                <div className="flex justify-center gap-8 mt-12 animate-fade-in">
                    <div className="flex flex-col items-center space-y-2 group">
                        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center group-hover:bg-green-200 transition-colors duration-300">
                            <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                            </svg>
                        </div>
                        <span className="text-sm text-gray-600 font-medium">Seguro</span>
                    </div>

                    <div className="flex flex-col items-center space-y-2 group">
                        <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center group-hover:bg-emerald-200 transition-colors duration-300">
                            <svg className="w-8 h-8 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                            </svg>
                        </div>
                        <span className="text-sm text-gray-600 font-medium">Rápido</span>
                    </div>

                    <div className="flex flex-col items-center space-y-2 group">
                        <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center group-hover:bg-teal-200 transition-colors duration-300">
                            <svg className="w-8 h-8 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
                            </svg>
                        </div>
                        <span className="text-sm text-gray-600 font-medium">Inteligente</span>
                    </div>
                </div>
            </div>
        </div>
    );
}